<template>
  <div>
    <b-form-group
      :label="$t('vehicleAvailableReason.name') + ':'"
      label-for="input-name"
    >
      <b-form-input id="name" type="text" v-model="model.name" />
      <span class="text-danger" v-if="modelstate['Name']">
        {{ "*" + modelstate["Name"][0] }}
      </span>
    </b-form-group>

    <b-form-group
      :label="$t('vehicleAvailableReason.type')"
      label-for="input-tipo"
    >
      <vehicle-available-reason-options
        :availabilityReason.sync="model.availabilityReason"
        :modelstate.sync="modelstate"
      />
    </b-form-group>

    <!-- {{ model }} -->
    <!-- {{ modelstate }} -->
  </div>
</template>

<script>
export default {
  name: "vehicleAvailableReason",
  components: {
    "vehicle-available-reason-options": () =>
      import(
        "@/components_rms/vehicle/VehicleAvailableReason/VehicleAvailableReasonOptions.vue"
      ),
  },
  props: {
    modelstate: Object,
    model: {
      type: Object,
      required: true,
      default: () => ({
        name: null,
        availabilityReason: null,
      }),
    },
  },
  data() {
    return {
      vehicleAvailableReasonId: null,
      optionsActivationReason: [
        { value: 1, text: "Desativação" },
        { value: 2, text: "Ativação" },
      ],
      options: [],
      localModel: {
        nameParam: null,
        availablingReasonparam: null,
      },
    };
  },
  watch: {
    model: {
      handler(newValue) {
        this.localModel.nameParam = newValue.name;
        this.localModel.availablingReasonparam = newValue.availabilityReason;
      },
      immediate: true,
    },
    nameParam(value) {
      this.$emit("update:model", { ...this.model, name: value });
    },
    availablingReasonparam(value) {
      this.$emit("update:model", { ...this.model, availabilityReason: value });
    },
  },
};
</script>